// Forces a minimum gap between consecutive WebSocket sends on a sip.js
// Transport, to work around a live-confirmed FreeSWITCH ws.c bug: two writes
// landing in the same underlying socket read can wedge FreeSWITCH's SIP
// parser, leaving the second message (and everything after it on that read)
// unprocessed for ~30-40s. sip.js's own 401/407 auth-retry logic
// (Session.authenticationGuard) always sends the challenge's ACK and the
// retried, credentialed INVITE back-to-back with zero gap - a reliable
// trigger, confirmed via live packet capture against dev.gudhub.com
// (2026-07-30): FreeSWITCH's kernel ACKs the retry INVITE's bytes within
// ~40ms of receipt, but the FreeSWITCH process doesn't read() them out of
// the socket for ~30-40s afterward. Not purely a message-size issue either -
// the same stall reproduced on a ~2.4KB audio-only INVITE, not just the
// larger video ones (see sdpModifiers.js's pruneVideoCodecs for a
// complementary, but not on its own sufficient, mitigation). Spacing is a
// blunt fix, but doesn't require patching/rebuilding FreeSWITCH itself.
const SEND_SPACING_MS = 75;

export function patchTransportSendSpacing(transport) {
    const originalSend = transport.send.bind(transport);
    let lastSendAt = 0;

    transport.send = async (message) => {
        const wait = lastSendAt + SEND_SPACING_MS - Date.now();
        if(wait > 0) await new Promise((resolve) => setTimeout(resolve, wait));
        lastSendAt = Date.now();
        return originalSend(message);
    };
}
